import { render, staticRenderFns } from "./PerTrain.vue?vue&type=template&id=49568240&scoped=true&"
import script from "./PerTrain.vue?vue&type=script&lang=js&"
export * from "./PerTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49568240",
  null
  
)

export default component.exports